module.exports = __webpack_public_path__ + "static/get-approved-8e8b679e249c9fc42f45db0026ee15e3.png";